define([
	"dojo/_base/declare",
	"csi/comm",
	"Specification"
], function(declare, comm, Specification) {

	return declare(null, {
		/**
		 * @override
		 * Cache the sizeChartAdmin node to determine the controller against it in heading
		 */
		_onRootRequest: function(request) {
			request.addParameter(comm.QUERY_URL, [
				Specification.URL_ADMIN,
			], true);

			this.inherited(arguments);
		}
	});
});